import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const ArrowDown = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 25' {...rest}>
    {type === 'stroke' ? (
      <path
        d='m6 14.647 6 6.06m0 0 6-6.06m-6 6.06v-16'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M11.25 4.708a.75.75 0 0 1 1.5 0v14.176l4.717-4.764.056-.052a.75.75 0 0 1 1.061 1.05l-.05.057-6 6.06a.75.75 0 0 1-1.067 0l-6-6.06-.051-.057a.75.75 0 0 1 1.06-1.05l.057.052 4.717 4.764z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
